import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Election Day is Tue Nov 3, 2026 — the strip shows site-wide until the day
// ends (midnight ET, EST after DST falls back) and then never renders again.
// Brand separation: cherry on CGD pages, ink-on-off-white on Rhythm Report pages.
const ELECTION_DAY_END = "2026-11-04T00:00:00-05:00";

export default function VoteBanner() {
  const { pathname } = useLocation();
  if (new Date() >= new Date(ELECTION_DAY_END)) return null;
  const isRhythm = pathname.startsWith("/rhythm");

  return (
    <Link
      to="/lowdown/trump-5000-promise-fine-print"
      data-testid="election-vote-banner"
      className={`group block px-4 py-2.5 transition-colors duration-300 ${
        isRhythm
          ? "bg-[#F3F1ED] text-[#0B0A0F] hover:bg-[#E8E4DC]"
          : "bg-cherry text-white hover:bg-cherry-soft"
      }`}
    >
      <p
        className={`mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-2 text-center text-[11px] font-bold uppercase leading-relaxed tracking-[0.14em] sm:text-xs ${
          isRhythm ? "text-[#0B0A0F]" : "text-white"
        }`}
      >
        <span>Election Day · Tue Nov 3 — Vote Democratic up &amp; down the ballot</span>
        <span className="hidden md:inline">
          The $5,000 promise? Read the fine print first.
        </span>
        <ArrowRight
          className="h-3.5 w-3.5 shrink-0 transition-transform duration-300 group-hover:translate-x-1"
          aria-hidden="true"
        />
      </p>
    </Link>
  );
}
